<template>
	<footer class="footer-wrapper footer-layout1" style="background:#004085;" >
	<!-- 	<div class="container">
			<div class="footer-top">
				<div class="row align-items-center justify-content-between">
					<div class="col-sm-6 col-md-auto pt-20 pt-sm-0 pb-20 pb-sm-0 text-center text-sm-end">
						<div class="footer-social" style="padding:60px 0;">
							<div class="ro-footer-qrcode">
								<img src="../../static/picture/ro_wechat.jpg" style="width: 80px;height:80px;"/>
								<div>关注公众号</div>
							</div>
							<div class="ro-footer-qrcode">
								<img src="../../static/picture/ro_wechat.jpg" style="width: 80px;height:80px;"/>
								<div>关注微博</div>
							</div>
							<div class="ro-footer-qrcode">
								<img src="../../static/picture/ro_wechat.jpg" style="width: 80px;height:80px;"/>
								<div>睿鸥科技</div>
							</div>
						</div>
							
					</div>
				</div>
			</div>
		</div> -->
		<div class="widget-area">
			<div class="container">
				<div class="row justify-content-between">
					<!-- 联系我们 -->
					<div class="col-md-4 col-lg-3 col-xl-5">
						<div class="widget footer-widget" style="text-align: left;">
							<h3 class="widget_title">
								联系我们
								<div style="font-size: 14px;">contact us</div>
							</h3>
							
							<div class="footer-table">
								<table>
									<tr>
										<td>地址:</td>
									</tr>
									<tr>
										<td>邮编:</td>
									</tr>
									<tr>
										<td>电话:</td>
									</tr>
									<tr>
										<td>邮箱:</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
					
					
	
					<!-- 友情链接 -->
					<div class="col-md-5 col-lg-auto col-xl-auto">
						<div class="widget footer-widget widget_nav_menu" style="text-align: left;">
							<h3 class="widget_title">
								友情链接
								<div style="font-size: 14px;">Friendly Link</div>
							</h3>
							<div class="menu-all-pages-container">
								<ul class="menu">
								</ul>
							</div>
						</div>
					</div>
					<div class="col-md-3 col-lg-3 col-xl-auto">
						<div class="widget footer-widget widget_nav_menu" style="text-align: left;">
							<h3 class="widget_title">
								公众号
								<div style="font-size: 14px;">weixin </div>
							</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
                <div class="copyright bg-theme">
		    <div class="container">
		        <div class="row align-items-center"> <!-- justify-content-between -->
		            <div class="col-auto text-center text-md-end">
		                <p class="mb-0 text-white">
		                    版权所有：骐众科技（深圳）有限公司@2028 2024-12-29 21:42:34  网站技术支持：13761553206   
		                    <a style="color: white;" target="_blank" href="https://beian.miit.gov.cn/">粤ICP备2023045065号-1</a>
		                </p>
		            </div>
		        </div>
		    </div>
		</div>
	</footer>
</template>
<script>
	export default {
		name: "rofooter",
		data: function() {
			return {
				message: "组件启动中...",
			};
		},
	};
</script>

<style>
	@import url("../../static/css/css2.css");
	@import url("../../static/css/app.min.css");
	@import url("../../static/css/fontawesome.min.css");
	@import url("../../static/css/animate.min.css");
	@import url("../../static/css/style.css");
	
	.ro-footer-qrcode{
		float: left;
		margin-right: 10px;
		color:white;
		font-size: 12px;
		text-align: center;
	}
</style>
